import { Card, Dialog, DialogContent, Snackbar } from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
import Page from "../components/Page";
import {
  AgregarPersonaBoton,
  PersonasTabla,
} from "../sections/@catalogos/personas";
import MuiAlert from "@mui/material/Alert";

const Personas = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });
  const [bodyDialog, setBodyDialog] = useState("");
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  return (
    <>
      <Page title="Catálogo de Personas">
        <Container maxWidth="xl">
          <AgregarPersonaBoton
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setErrorGraph={setErrorGraph}
            setOpenSnackBar={setOpenSnackBar}
          />
          <Card>
            <PersonasTabla
              setOpenDialog={setOpenDialog}
              setBodyDialog={setBodyDialog}
              setErrorGraph={setErrorGraph}
              setOpenSnackBar={setOpenSnackBar}
            />
          </Card>
        </Container>
        <Dialog open={openDialog}>
          <DialogContent>{bodyDialog}</DialogContent>
        </Dialog>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={errorGraph.severity}
            sx={{ width: "100%" }}
          >
            {errorGraph.mensaje}
          </Alert>
        </Snackbar>
      </Page>
    </>
  );
};

export default Personas;
